import toPropertyKey from "./toPropertyKey.js";
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
export { _defineProperty as default };


//////////////////
// WEBPACK FOOTER
// ../@babel/runtime/helpers/esm/defineProperty.js
// module id = 567
// module chunks = 22